// 设置播放器输出设备
import { 
    cppGetEnvVar,
    cppIniReadValue,
    cppIniWriteValue,
    cppRegReadValue,
    cppRegWriteValue,
    cppShellExecuteEx,
} from '../../../api/cpp'

// 将酷狗播放器设置为默认输出设备
export function setKuGouDefaultDev() {
    const appdataPath = cppGetEnvVar("appdata");
    const kugouIniPath = `${appdataPath}\\KuGou8\\KuGou.ini`;
    // 获取当前输出设备
    const audioRendererName = cppIniReadValue(kugouIniPath, "OutputConfigSection", "AudioRendererName");
    console.log(audioRendererName)
    // 将现在的输出设备写入注册表 以便还原
    const regWriteRes = cppRegWriteValue("HKCU", "SOFTWARE\\acchelper", "kugourendername", audioRendererName);
    console.log("写入注册表结果", regWriteRes)
    if (audioRendererName && audioRendererName !== "Default DirectSound Device") {
        console.log("非默认设备")
        // 如果酷狗播放设备不是默认设备 则将酷狗播放设备设置为默认设备
        cppShellExecuteEx({
            lpFile: 'cmd.exe',
            lpVerb: 'runas',
            lpParameters: '/c taskkill /f /t /im KuGou.exe',
            nShow: 0
        })
        setTimeout(() => {
            const iniWriteRes = cppIniWriteValue(kugouIniPath, "OutputConfigSection", "AudioRendererName", "Default DirectSound Device")
            console.log("写入酷狗配置结果", iniWriteRes)
        }, 1000)
    }
}
// 还原酷狗播放器输出设备设置
export function setKuGouOriginalDev() {
    const appdataPath = cppGetEnvVar("appdata");
    const kugouIniPath = `${appdataPath}\\KuGou8\\KuGou.ini`;
    // 获取之前写入的酷狗输出设备
    const curDev = cppRegReadValue("HKCU", "SOFTWARE\\acchelper", "kugourendername")
    console.log("读取注册表结果", curDev)
    if (curDev && typeof curDev === "string" && curDev !== "Default DirectSound Device") {
        // 恢复酷狗播放设备设置
        cppShellExecuteEx({
            lpFile: 'cmd.exe',
            lpVerb: 'runas',
            lpParameters: '/c taskkill /f /t /im KuGou.exe',
            nShow: 0
        })
        setTimeout(() => {
            const iniWriteRes = cppIniWriteValue(kugouIniPath, "OutputConfigSection", "AudioRendererName", curDev)
            console.log("写入酷狗配置结果", iniWriteRes)
        }, 1000)
    }
}


// 将繁星播放器设置为默认输出设备
export function setFanXingDefaultDev() {
    const appdataPath = cppGetEnvVar("appdata");
    const iniPath = `${appdataPath}\\FXbanzou\\Fanxingbobo.ini`;
    const curDevIndex = cppIniReadValue(iniPath, "FanxingBobo", "AUDIOOUT");
    cppRegWriteValue("HKCU", "SOFTWARE\\acchelper", "fanxingaudiooutdevindex", curDevIndex);
    if (curDevIndex && curDevIndex !== "0") {
        cppShellExecuteEx({
            lpFile: 'cmd.exe',
            lpVerb: 'runas',
            lpParameters: '/c taskkill /f /t /im FanXingBanZou.exe',
            nShow: 0
        })
        setTimeout(() => {
            cppIniWriteValue(iniPath, "FanxingBobo", "AUDIOOUT", "0")
        }, 1000)
    }
}
// 还原繁星播放器输出设备设置
export function setFanXingOriginalDev() {
    const appdataPath = cppGetEnvVar("appdata");
    const iniPath = `${appdataPath}\\FXbanzou\\Fanxingbobo.ini`;
    const curDevIndex = cppRegReadValue("HKCU", "SOFTWARE\\acchelper", "fanxingaudiooutdevindex")
    if (curDevIndex && typeof curDevIndex === "string" && curDevIndex !== "0") {
        cppShellExecuteEx({
            lpFile: 'cmd.exe',
            lpVerb: 'runas',
            lpParameters: '/c taskkill /f /t /im FanXingBanZou.exe',
            nShow: 0
        })
        setTimeout(() => {
            cppIniWriteValue(iniPath, "FanxingBobo", "AUDIOOUT", curDevIndex)
        }, 1000)
    }
}


// 将酷我播放器设置为默认输出设备
export function setKuWoDefaultDev() {
    const iniPath = `C:\\ProgramData\\kuwodata\\kwmusic2013\\Conf\\user\\config.ini`
    const curDevName = cppIniReadValue(iniPath, "Device", "OutDevName");
    const curDevId = cppIniReadValue(iniPath, "Device", "OutDevID");
    cppRegWriteValue("HKCU", "SOFTWARE\\acchelper", "kuwodevname", curDevName);
    cppRegWriteValue("HKCU", "SOFTWARE\\acchelper", "kuwodevid", curDevId);
    if (curDevName && curDevName !== "Default DirectSound Device") {
        cppShellExecuteEx({
            lpFile: 'cmd.exe',
            lpVerb: 'runas',
            lpParameters: '/c taskkill /f /t /im kwmusic.exe',
            nShow: 0
        })
        setTimeout(() => {
            cppIniWriteValue(iniPath, "Device", "OutDevName", "Default DirectSound Device")
            cppIniWriteValue(iniPath, "Device", "OutDevID", "")
        }, 1000)
    }
}
// 还原酷我播放器输出设备设置
export function setKuWoOriginalDev() {
    const iniPath = `C:\\ProgramData\\kuwodata\\kwmusic2013\\Conf\\user\\config.ini`;
    const devName = cppRegReadValue("HKCU", "SOFTWARE\\acchelper", "kuwodevname");
    const devId = cppRegReadValue("HKCU", "SOFTWARE\\acchelper", "kuwodevid");
    if (devName && typeof devName === "string" && devName !== "Default DirectSound Device") {
        cppShellExecuteEx({
            lpFile: 'cmd.exe',
            lpVerb: 'runas',
            lpParameters: '/c taskkill /f /t /im kwmusic.exe',
            nShow: 0
        })
        setTimeout(() => {
            cppIniWriteValue(iniPath, "Device", "OutDevName", devName)
            cppIniWriteValue(iniPath, "Device", "OutDevID", devId)
        }, 1000)
    }
}

// 将网易云播放器设置为默认输出设备  网易云不考虑还原  只需要删除配置文件即可设置为默认设备
export function setNetEaseDefaultDev() {
    const localappdataPath = cppGetEnvVar("localappdata");
    const localConfigPath = `${localappdataPath}\\NetEase\\CloudMusic\\localdata`;
    cppShellExecuteEx({
        lpFile: 'cmd.exe',
        lpVerb: 'runas',
        lpParameters: '/c taskkill /f /t /im cloudmusic.exe',
        nShow: 0
    })
    setTimeout(() => {
        cppShellExecuteEx({
            lpFile: 'cmd.exe',
            lpVerb: '',
            lpParameters: `/c del /q "${localConfigPath}"`,
            nShow: 0
        })
    }, 1000)
}

// 将全民播放器设置为默认输出设备  全民不考虑还原  只需要删除配置文件即可设置为默认设备
export function setWeSingDefaultDev() {
    const appdataPath = cppGetEnvVar("appdata");
    const localConfigPath = `${appdataPath}\\Tencent\\WeSing\\User Data\\ConfigInfo2.dat`;
    cppShellExecuteEx({
        lpFile: 'cmd.exe',
        lpVerb: 'runas',
        lpParameters: '/c taskkill /f /t /im WeSing.exe',
        nShow: 0
    })
    setTimeout(() => {
        cppShellExecuteEx({
            lpFile: 'cmd.exe',
            lpVerb: '',
            lpParameters: `/c del /q "${localConfigPath}"`,
            nShow: 0
        })
    }, 1000)
}
